/**
 * Quem se está a assistir em cada chamada — a memória do opt-in, fora do React.
 *
 * «Assistir tela» é uma escolha, não um estado de ligação: a tela já está a ser
 * recebida, o que se guarda é a decisão de a ver. Essa decisão vivia num
 * `useState` do `VoiceStage`, e carregar em «Discord» DESMONTA o escritório
 * inteiro — com ele o palco, com ele a lista. Quem voltava encontrava as telas
 * outra vez fechadas, com o botão «Assistir tela» a pedir o que já tinha pedido.
 *
 * Mesma solução do `officeBody`, e pela mesma razão: um `Map` ao nível do
 * módulo, que a montagem seguinte encontra cheio. A chave é o canal — voltar a
 * uma chamada é voltar ao que se estava a ver lá, e mudar de sala não arrasta a
 * escolha da sala anterior.
 *
 * É de SESSÃO, como a posição no mapa: um F5 recomeça sem ninguém a ser
 * assistido, que é o comportamento certo para uma escolha explícita.
 *
 * Em desenvolvimento vive no `import.meta.hot.data` para o Fast Refresh não a
 * deitar fora a cada ficheiro guardado — guardar o `VoiceStage` a meio de uma
 * reunião fechava as telas de toda a gente.
 */

import type { Snowflake } from "@greenvoice/shared";

const aAssistir: Map<Snowflake, readonly string[]> = import.meta.hot?.data?.aAssistir ?? new Map();
if (import.meta.hot?.data) import.meta.hot.data.aAssistir = aAssistir;

/** Quem eu estava a assistir nesta chamada. Vazio se nunca escolhi nada aqui. */
export function assistidosLembrados(channelId: Snowflake | null): readonly string[] {
  if (channelId === null) return [];
  return aAssistir.get(channelId) ?? [];
}

/** Guarda a escolha. Cópia à entrada: quem chama tem o seu próprio array e pode
 *  continuar a mexer-lhe sem mudar o que ficou guardado. */
export function lembrarAssistidos(channelId: Snowflake | null, ids: readonly string[]): void {
  if (channelId === null) return;
  aAssistir.set(channelId, [...ids]);
}
